export { default } from './BatchActionsListItem';



// WEBPACK FOOTER //
// ./app/components/shared/BatchActions/BatchActionsListItem/index.js